import { useState, useEffect } from 'react';
import { Stack, IconButton, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

function QuantityControl({
  value = 0,
  onChange,
  min = 0,
  max,
  disabled = false,
  size = 'small',
  width = '60px',
}) {
  const [localValue, setLocalValue] = useState(String(value));
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setLocalValue(String(value));
    }
  }, [value, isFocused]);

  const commit = raw => {
    const parsed = parseInt(raw, 10);
    const numeric = Number.isFinite(parsed) ? parsed : min;
    const clamped = max !== undefined ? Math.min(max, Math.max(min, numeric)) : Math.max(min, numeric);
    onChange(clamped);
    setLocalValue(String(clamped));
  };

  const handleIncrement = () => {
    const newValue = value + 1;
    if (max !== undefined && newValue > max) return;
    onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max(min, value - 1);
    onChange(newValue);
  };

  const canIncrement = max === undefined || value < max;
  const canDecrement = value > min;

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <IconButton
        size={size}
        onClick={handleDecrement}
        disabled={disabled || !canDecrement}
        sx={{
          '&.Mui-disabled': {
            color: '#808080',
          },
        }}
      >
        <RemoveIcon />
      </IconButton>
      <TextField
        value={localValue}
        onChange={e => setLocalValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setIsFocused(false);
          commit(localValue);
        }}
        size={size}
        disabled={disabled}
        sx={{
          width: width,
          '& .MuiInputBase-input': {
            textAlign: 'center',
            padding: '8px 4px',
          },
        }}
        inputProps={{
          min: min,
          max: max,
          style: { textAlign: 'center' },
        }}
      />
      <IconButton
        size={size}
        onClick={handleIncrement}
        disabled={disabled || !canIncrement}
        sx={{
          '&.Mui-disabled': {
            color: '#808080',
          },
        }}
      >
        <AddIcon />
      </IconButton>
    </Stack>
  );
}

export default QuantityControl;
